'use client';
import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgRefund = function SvgRefund(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.994 5.5h-7M11.997 5.5a8 8 0 1 1-8 8M12 10.143v-.764M12 17.016v.763",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.01 16.196c.297.485.804.82 1.417.82h1.255a1.607 1.607 0 0 0 .39-3.169l-2.148-.54a1.607 1.607 0 0 1 .391-3.167h1.2570000000000001c.61 0 1.117.335 1.412.82M7.994 2.5l-3 3M7.994 8.5l-3-3",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgRefund as default };
//# sourceMappingURL=refund.svg.js.map
